import { inject, injectable } from "@launchtray/tsyringe-async";
import { UpdateFirstTimeExperienceInputBody } from "by/gamefactory/cityversetycoon/networking/data/responses/firsttimeexperience/UpdateFirstTimeExperienceInputBody";
import { IFirstTimeExperienceModel } from "../models/IFirstTimeExperienceModel";
import { IFirstTimeExperienceController } from "./IFirstTimeExperienceController";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";

@injectable()
export class FirstTimeExperienceController implements IFirstTimeExperienceController {
    private readonly firstTimeExperienceModel: IFirstTimeExperienceModel;
    private readonly logger: ILogger;

    public constructor(
        @inject("IFirstTimeExperienceModel") firstTimeExperienceModel: IFirstTimeExperienceModel,
        @inject("ILogger") logger: ILogger
    ) {
        this.firstTimeExperienceModel = firstTimeExperienceModel;
        this.logger = logger;
    }

    public async sendShownTooltip(input: Partial<UpdateFirstTimeExperienceInputBody>): Promise<void> {
        try {
            await this.firstTimeExperienceModel.sendShownTooltip(input);
        } catch (e: unknown) {
            this.logger.error(e);
        }
    }

    public async getFirstTimeExperience(): Promise<void> {
        await this.firstTimeExperienceModel.getFirstTimeExperience();
    }
}
